import { createAxios, logNative } from '../../utils/utils';
import {
  APP_DETAILS_70,
  APP_DETAILS_GIFT_70,
  APP_FORUM_RELATED_74,
  SPECIAL_COLLECT_SET_72,
  SPECIAL_COLLECT_CANCEL_72,
  APP_DETAILS_GIFT_RECEIVE_70,
} from '../../config';
import React from 'react';
import Toast from '../../components/Toast/Toast';
import styles from './SoftDetail.module.less';

export default {
  async getAppDetails({ softid, bizInfo }) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.get(APP_DETAILS_70, { params: { softid, bizInfo: bizInfo || {} } });
      if (res.data.status === 0) {
        return {
          ...res.data.data,
          paramSoftId: softid,
          loading: false,
        };
      } else {
        return {
          ...res.data,
          paramSoftId: softid,
          loading: false,
        };
      }
    } catch (error) {
      logNative('获取软件详情失败');
      return error;
    }
  },
  async getAppGift({ softInfo, androidType }) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.get(APP_DETAILS_GIFT_70, {
        params: { softInfo, androidType },
      });

      if (res.data && res.data.status === 0) {
        return {
          dataList: [...res.data.data],
          softInfo,
        };
      }
    } catch (error) {
      logNative(`获取pc软件getAppGift接口错误： ${error}`);
      return error;
    }
  },
  async getAppForumRelated(params) {
    try {
      const axios = await createAxios();
      const res = await axios.get(APP_FORUM_RELATED_74, {
        params: params,
      });

      if (res.data.status === 0) {
        return {
          ...params,
          forumList: (res.data.data && res.data.data.forumContentList) || [],
        };
      } else {
        return {
          ...params,
          forumList: [],
        };
      }
    } catch (error) {
      return {
        ...params,
        forumList: [],
      };
    }
  },
  async addCollectSpecial(payload, pcAppInfo) {
    const axios = await createAxios('isNeedUser');
    const res = await axios.get(SPECIAL_COLLECT_SET_72, {
      params: payload,
    });

    try {
      if (res && res.data && res.data.status === 0) {
        Toast.success({
          content: '收藏成功!',
        });
        return {
          ...pcAppInfo,
          hasCollect: 1,
        };
      } else {
        Toast.error({
          content: '收藏失败!',
        });
        return pcAppInfo;
      }
    } catch (err) {
      logNative(err);
      return pcAppInfo;
    }
  },
  async deleteCollectSpecial(payload, pcAppInfo) {
    const axios = await createAxios('isNeedUser');
    const res = await axios.get(SPECIAL_COLLECT_CANCEL_72, {
      params: payload,
    });
    try {
      if (res && res.data && res.data.status === 0) {
        // 不是列表页面toast提示
        if (payload.source !== 'list') {
          Toast.success({
            content: <div className={styles.toast}>取消收藏成功!</div>,
            className: styles.toast_img,
          });
          return {
            ...pcAppInfo,
            hasCollect: 0,
          };
        }
      } else {
        Toast.error({
          content: <div className={styles.toast}>取消收藏失败!</div>,
          className: styles.toast_img,
        });
        return pcAppInfo;
      }
    } catch (err) {
      logNative(err);
      return pcAppInfo;
    }
  },
  async recieveGift(params) {
    try {
      const axios = await createAxios('isNeedUser');
      const res = await axios.get(APP_DETAILS_GIFT_RECEIVE_70, {
        params,
      });

      if (res.data) {
        if (res.data.status === 0) {
          Toast.success({
            content: res.data.message,
          });
        } else {
          Toast.error({
            content: res.data.message,
          });
        }
      }

      if (res.data) {
        return {
          loading: false,
          data: res.data,
          ...params,
        };
      }
    } catch (error) {
      // throw error;
    }
  },
  async getCommentInfo() {
    try {
      const axios = await createAxios('isNeedUser');
      // const res = await axios.get(APP_DETAILS_GIFT_RECEIVE_70, {
      //   params,
      // });
    } catch (err) {
      logNative(`获取评论相关信息报错${err}`);
    }
  },
};
